import { render, staticRenderFns } from "./company.vue?vue&type=template&id=1d16a925"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports